
import Lightaudio from "../../assets/audio/light.mp3";
export default {
  data() {
    return {
      isAudioPlaying: false,
      audio: {},
      sheet: false
    };
  },
  watch: {
    sheet(val) {
      if (!val && this.isAudioPlaying) {
        this.isAudioPlaying = false;
        this.playAlert();
      }
    }
  },
  created() {
    this.audio = new Audio(Lightaudio);
    this.audio.addEventListener(
      "ended",
      function() {
        this.currentTime = 0;
        this.play();
      },
      false
    );
    this.$nuxt.$on("start-audio-alert", this.playAlert);
    this.$nuxt.$on("stop-audio-alert", this.stopAlert);
  },

  methods: {
    playAlert() {
      if (
        this.$ls.get("volumeEnabled", "") !== "" &&
        this.$ls.get("volumeEnabled", "") !== "false" &&
        !this.isAudioPlaying
      ) {
        this.isAudioPlaying = true;
        if (this.isAndroid()) {
          Android.startAudioAlert();
        } else {
          this.audio
            .play()
            .then(() => {
              console.log("Audio played");
              // already allowed
            })
            .catch((e) => {
              console.log(e);
              this.sheet = true;
            });
        }
      }
    },
    stopAlert() {
      this.isAudioPlaying = false;
      if (this.isAndroid()) {
        Android.stopAudioAlert();
      } else {
        this.audio.pause();
        this.audio.currentTime = 0;
      }
    }
  },
  beforeDestroy() {
    this.$nuxt.$off("start-audio-alert");
    this.$nuxt.$off("stop-audio-alert");
  }
};
